import { render, staticRenderFns } from "./AdminTagForm.vue?vue&type=template&id=81f19b70"
import script from "./AdminTagForm.vue?vue&type=script&lang=ts"
export * from "./AdminTagForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports